module.exports = __webpack_public_path__ + "img/Antithesis-2.db6fa882.png";